import { User } from '@/modules/settings/users/types/User.ts'
import { appConfig } from '@/config/app.ts'

export interface UserState {
  isLoading: boolean
  users: User[]
  isCreateModalOpen: boolean
  editId: string | null
  filters: string
}

export const initialState: UserState = {
  isLoading: false,
  users: [],
  isCreateModalOpen: false,
  editId: null,
  filters: `?limit=${appConfig.pagination.defaultValue}`
}
